import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../redux/hooks";
import { css } from "../../../../styled-system/css";
import { VStack } from "../../../../styled-system/jsx";
import { TextField } from "../../../components/fields/base/TextField";
import { LanguageSelector } from "../components/LanguageSelector";

const ProfileSettingsSection = () => {
  const { t } = useTranslation(["settings"]);
  const user = useAppSelector((state) => state.user);

  return (
    <VStack css={{ gap: "medium", alignItems: "start", paddingY: "medium", fontSize: "medium" }}>
      <h4
        className={css({
          margin: 0,
          paddingX: "large",
          fontWeight: 500,
        })}
      >
        {t(($) => $.settings.profile["Profile Settings"])}
      </h4>
      <VStack gap={"large"} alignItems={"start"} width={"500px"} padding={"large"}>
        <TextField
          label={t(($) => $.settings.profile.Name)}
          css={{ width: "100%" }}
          value={user.user_full_name}
          isDisabled={true}
        />
        <TextField
          label={t(($) => $.settings.profile["Email Address"])}
          css={{ width: "100%" }}
          value={user.email ?? ""}
          isDisabled={true}
        />
        <LanguageSelector />
      </VStack>
    </VStack>
  );
};

export default ProfileSettingsSection;
